/*eslint-disable */
const $ = window.jQuery = require('jquery'); 
import ppLeftSidebar from '../paperpile-left-sidebar';
import axios from 'axios';
import {
mapGetters,
} from 'vuex';
export default {
  name: 'paper-preferences',
  components: {
    'pp-left-sidebar' : ppLeftSidebar
  },
  props: [],
  data () {
    return {
      preferencesTabState:'proxy_access'
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    preferencesTabActvMethod(tabName){
      this.preferencesTabState = tabName
    }
  },
  watch:{
  },
  beforeCreate:function(){
    $('body').addClass('researchfile_body_wrp')
  },
  beforeRouteLeave: function(to, from, next) {
    if(to.name != 'awerackResearchGroup' && to.name != 'paperPiles' && to.name != 'bucketDetails'){
      $('body').removeClass('researchfile_body_wrp');
    }
    next();
  },
}